import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-inscricao',
  templateUrl: './inscricao.component.html',
  styleUrls: ['./inscricao.component.scss']
})
export class InscricaoComponent implements OnInit {

  form: FormGroup;
  public ativa : boolean = true;
  constructor( private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {

    

  }

  retorna(){
    // navega para a tela de login
    this.router.navigate(['/menu']);

    };

  



}
